import { render, staticRenderFns } from "./TMultiSelect.vue?vue&type=template&id=1624f278&"
import script from "./TMultiSelect.vue?vue&type=script&lang=js&"
export * from "./TMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VFlex})
